module.exports = __webpack_public_path__ + "static/media/testimony2.19025205.png";